// import node module libraries
// import node module libraries
import React, {useEffect, useMemo, useState} from 'react';
import {useParams} from 'react-router-dom';
// import utility file
// import utility file
import {Card, Col, Row, Table} from 'react-bootstrap';
import {useFilters, useGlobalFilter, usePagination, useTable} from 'react-table';
import HistoriquepaiementService from '../../services/HistoriquepaiementService';
import SuivipaiementProfileLayout from './SuivipaiementProfileLayout';

// import custom components
// import custom components
import GlobalFilter from 'components/elements/advance-table/GlobalFilter';
import Pagination from 'components/elements/advance-table/Pagination';

const ViewHistoriquepaiement = () => {
    const {id} = useParams();
    const [historiquepaiements, setHistoriquepaiement] = useState([]);

    useEffect(() => {
        HistoriquepaiementService.getAllHistoriquepaiements()
            .then(response => {
                // Assuming the response is an array
                const filteredData = response.filter(item => String(item.suivipaiement) === id);
                setHistoriquepaiement(filteredData);
            })
            .catch(error => {
                console.error("Error fetching historique paiements:", error);
            });
    }, [id]);

    const formatValue = (value, columnId) => {
        if (columnId === 'date') {
            // Convert the string to a Date object
            const dateObj = new Date(value);
            return dateObj.toISOString().split('T')[0];
        } else if (columnId === 'montant' || columnId === 'montant_restant') {
            return new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'XAF'}).format(value);
        }
        return value;
    };


    const columns = useMemo(
        () => [
            {accessor: 'id', Header: 'ID', show: false},
            {
                accessor: 'date',
                Header: 'Date',
                Cell: ({value}) => <div>{formatValue(value, 'date')}</div>
            },
            {
                accessor: 'montant',
                Header: "Montant versé",
                Cell: ({value}) => <div>{formatValue(value, 'montant')}</div>
            },
            {
                accessor: 'montant_restant',
                Header: "Montant restant",
                Cell: ({value}) => <div>{formatValue(value, 'montant_restant')}</div>
            },
        ],
        []
    );
    const data = useMemo(() => {
        if (historiquepaiements) {
            return historiquepaiements.map((historiquepaiement) => ({
                ...historiquepaiement,
            }));
        }
        return [];
    }, [historiquepaiements]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        state,
        gotoPage,
        pageCount,
        prepareRow,
        setGlobalFilter
    } = useTable(
        {
            columns,
            data,
            initialState: {
                pageSize: 10,
                hiddenColumns: columns.map((column) => {
                    if (column.show === false) return column.accessor || column.id;
                    else return false;
                })
            }
        },
        useFilters,
        useGlobalFilter,
        usePagination
    );

    const {pageIndex, globalFilter} = state;
    return (
        <SuivipaiementProfileLayout>
            {historiquepaiements && (
                <>
                    <Card className="mb-3 ">
                        {/* Card body */}
                        <Card.Body>
                            <div className="overflow-hidden p-3">
                                <Row className="justify-content-md-between mb-4 mb-xl-0 ">
                                    <Col xl={4} lg={4} md={6} xs={12}>
                                        <GlobalFilter
                                            filter={globalFilter}
                                            setFilter={setGlobalFilter}
                                            placeholder="Rechercher une date"
                                        />
                                    </Col>
                                </Row>
                            </div>

                            <Table
                                hover
                                responsive
                                {...getTableProps()}
                                className="text-nowrap table-centered"
                            >
                                <thead className="table-light">
                                {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map((column) => (
                                            <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                        ))}
                                    </tr>
                                ))}
                                </thead>
                                <tbody {...getTableBodyProps()}>
                                {page.map((row) => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()}>
                                            {row.cells.map((cell) => {
                                                return (
                                                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>

                            <Pagination
                                previousPage={previousPage}
                                pageCount={pageCount}
                                pageIndex={pageIndex}
                                gotoPage={gotoPage}
                                nextPage={nextPage}
                            />
                        </Card.Body>
                    </Card>
                </>
            )}
        </SuivipaiementProfileLayout>
    );
};

export default ViewHistoriquepaiement;
